import Badge from "tds/badge";

export { Badge };

customElements.define("tds-badge", Badge.CustomElementConstructor);
